import { compose } from 'redux';
import { connect } from 'react-redux';
import withAuthUser from '../../common/WithAuthUser';
import ListLiveStreamOrganizer, { Header } from '../../pages/LiveStreamOrganizer/ListLiveStreamOrganizer';
import { ClearGetListLiveStreamEvent, GetListLiveStreamEventRequested } from '../../actions/LiveStreamManagement';

const mapStateToProps = (state) => ({
    isLoading: state.livestream.getListLiveStream.isFetching,
    listEvent: state.livestream.getListLiveStream.data && state.livestream.getListLiveStream.data.results,
    currentPage: state.livestream.getListLiveStream.data.page,
    totalPage: state.livestream.getListLiveStream.data.total_page,
    role: Number(state.auth.credential.data.role),
    eventInfo: state.registration.registrationViewer.data,
});

const mapDispatchToProps = (dispatch) => ({
    fetchGetListLiveStream: (event_name) => {
        dispatch(GetListLiveStreamEventRequested(event_name));
    },
    fetchClearGetListLiveStream: () => {
        dispatch(ClearGetListLiveStreamEvent());
    },
});

export const ListLiveStreamHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuthUser,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListLiveStreamOrganizer);
